import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getMoneyText } from "../../functions";
import ProductTypeSpecs from "../../types/prtoduct-type-specs";
import { ProductSpecs } from "../../types/product";
import ProductProperty from "./property";
import { localizeNumbers } from "../../functions";

export interface ProductProps {
  title: string;
  mainPrice?: number;
  finalPrice: number;
  packageTitle?: string;
  desc: string;
  onSelect?: () => void;
  onhandleClick?: () => void;
  Specs: ProductTypeSpecs;
  productSpecs: ProductSpecs[];
  medium?: number;
  productType?: number;
  hasSnappPay: Boolean;
}
export default function ProductItem({
  title,
  mainPrice,
  finalPrice,
  Specs,
  productSpecs,
  onSelect,
  onhandleClick,
  productType,
  packageTitle,
  hasSnappPay,
}: ProductProps) {
  return (
    <div className="col-12 col-sm-6 col-lg-4 col-xl-4 px-1 mb-3">
      <div className="dh-zoom-1">
        <div className="d-style active btn-light btn-h-outline-blue btn-a-outline-blue bgc-white mt-lg-n2 w-100 border-t-3  shadow-sm">
          <div className="d-flex flex-column align-items-center">
            {packageTitle && (
              <span className="mt-n25 mr-2px !absolute block">
                <span className="badge badge-lg bgc-orange-d2 brc-orange-d2 text-white arrowed-in arrowed-in-right z-[999]">
                  {packageTitle}
                </span>
              </span>
            )}
            {/*  start show in mobile */}
            <div className="xxs:w-full xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2 service-page-item-box block sm:hidden relative ">
              <table className="border-collapse text-sm w-full m-0">
                <tbody>
                  <tr>
                    <td className="border p-3">
                      <span className="inline-block"> {title} </span>
                      {productType !== 6 &&
                        productType !== 4 &&
                        productSpecs
                          .filter(
                            (spec) =>
                              Specs[spec.specId].specStatus &&
                              spec.specId !== 4 &&
                              spec.specId !== 0
                          )
                          .map((spec) => (
                            <>
                              {<span> ، </span>}
                              <span className="inline-block">
                                {`${localizeNumbers(spec.value)} ${
                                  spec.unit
                                    ? localizeNumbers(spec.unit)
                                    : Specs[spec.specId]?.unit || ""
                                }`}
                                {(spec.description?.length || 0) > 0 ? (
                                  <span className="grey">
                                    {` (${spec.description})`}
                                  </span>
                                ) : (
                                  <></>
                                )}
                              </span>
                            </>
                          ))}

                      {mainPrice && mainPrice > finalPrice && (
                        <del id="Discount">
                          <span className="font-bolder">
                            {getMoneyText(mainPrice).amount}
                          </span>
                          <span className="lighter text-orange">تومان</span>
                        </del>
                      )}
                      <span
                        className="bigger-150 font-bolder orange text-orange"
                        id="FinalPrice"
                      >
                        {getMoneyText(finalPrice).amount}
                      </span>
                      <span className="smaller-90 lighter text-orange">
                        تومان
                      </span>
                    </td>
                    <td
                      className="border p-2 bgc-orange cursor-pointer"
                      onClick={() => {
                        onSelect && onSelect();
                        onhandleClick && onhandleClick();
                      }}
                    >
                      {hasSnappPay && (
                        <img
                          src="/snapp.svg"
                          alt="خرید قسطی"
                          className="absolute bottom-[-1.5em] left-[0.5em] w-5 h-16"
                        />
                      )}
                      <FontAwesomeIcon
                        icon={"shopping-cart"}
                        className="text-white"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* end show in mobile */}
            <div className="w-full text-gray-800 text-sm hidden sm:block relative">
              <h4 className="text-white text-sm font-extrabold text-center bg-gray-700 py-3 px-2 rounded-md">
                {title}
              </h4>
              {productType !== 6 &&
                productType !== 4 &&
                productSpecs
                  .filter(
                    (spec) =>
                      Specs[spec.specId].specStatus &&
                      spec.specId !== 4 &&
                      spec.specId !== 0
                  )
                  .map((spec) => (
                    <ProductProperty
                      key={spec.specId}
                      spec={Specs[spec.specId]}
                      productSpecUnit={spec.unit}
                      value={spec.value}
                      description={spec.description}
                      imageUrl={spec.imageUrl}
                    />
                  ))}

              <div
                className="text-white text-sm font-extrabold text-center bgc-orange pt-3 pb-3 pr-2 pl-2 cursor-pointer"
                onClick={() => {
                  onSelect && onSelect();
                  onhandleClick && onhandleClick();
                }}
              >
                {hasSnappPay && (
                  <img
                    src="/snapp.svg"
                    alt="خرید قسطی"
                    className="absolute bottom-[-1.5em] left-[0.5em] w-10 h-16"
                  />
                )}
                <FontAwesomeIcon
                  icon={"shopping-cart"}
                  className="text-white"
                />
                {mainPrice && mainPrice > finalPrice && (
                  <del className="Discount">
                    <span className="font-bolder">
                      {getMoneyText(mainPrice).amount}
                    </span>
                    <span className="smaller-80 lighter"> تومان</span>
                  </del>
                )}
                <span className="bigger-150 font-bolder orange" id="FinalPrice">
                  {getMoneyText(finalPrice).amount}
                </span>
                <span className="smaller-80 lighter  px-1">تومان</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
